'use client';

import { isSuccess, type Result } from '@carvana/merch-result';
import { use } from 'react';
import { z } from 'zod';
import { useCreditApplicationUpdate } from '~/context/flp-rsc/CreditApplicationUpdateContext';
import { usePricingUpdate } from '~/context/flp-rsc/PricingUpdateContext';
import { PricingAggregates } from '~/contracts/flp';
import InventoryCountLine from './InventoryCountLine';
import { InventoryLineSkeleton } from '../../skeletons';

const TotalMatchingInventorySchema = z.number();

type OwnProps = {
  expiration: string;
  pricingAggregates: Promise<Result<PricingAggregates> | undefined>;
};

function getInventory(result: Result<PricingAggregates> | undefined): number {
  if (!result || !isSuccess(result)) {
    return 0;
  }

  const parsed = TotalMatchingInventorySchema.safeParse(
    result.content.totalMatchingInventory
  );

  if (!parsed.success) {
    return 0;
  }

  return parsed.data;
}

export default function InventoryLineGate({
  expiration,
  pricingAggregates
}: OwnProps) {
  const { isPending: isPricingPending } = usePricingUpdate();
  const { isPending: isCreditApplicationPending } =
    useCreditApplicationUpdate();

  if (isPricingPending || isCreditApplicationPending) {
    return <InventoryLineSkeleton />;
  }

  const result = use(pricingAggregates);
  const inventory = getInventory(result);

  if (inventory <= 0) {
    return <h2>You can start shopping with real financing terms!</h2>;
  }

  return <InventoryCountLine expiration={expiration} inventory={inventory} />;
}
